var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Banner'),_c('Part1'),_c('Part2'),_c('Part3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }